import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Services/login.service';

@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.css']
})
export class MenuLateralComponent implements OnInit {

  menus: NodeList;

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    // if (this.loginService.estaLogado()) {
    //   //this.menus = this.loginService.carregarMenu();
    // } else {
    //   this.loginService.handleLogin();
    // }
  }
}
